"use client"

import { cn } from "@/lib/utils"

interface DividerHandleProps {
  axis: "horizontal" | "vertical"
  onMouseDown: (e: React.MouseEvent) => void
  onDoubleClick?: () => void
  className?: string
}

/**
 * Figma-style drag handle with exclude.svg centered on a line.
 *
 * Horizontal = full-width line + handle    (between top/bottom panels)
 * Vertical   = full-height line + handle   (between left/right panels)
 */
export function DividerHandle({
  axis,
  onMouseDown,
  onDoubleClick,
  className,
}: DividerHandleProps) {
  if (axis === "horizontal") {
    return (
      <div
        className={cn(
          "relative z-10 flex h-5 w-full shrink-0 cursor-row-resize select-none items-center justify-center",
          className,
        )}
        onMouseDown={onMouseDown}
        onDoubleClick={onDoubleClick}
      >
        {/* continuous line */}
        <div className="pointer-events-none absolute top-1/2 h-px w-full -translate-y-1/2 bg-[#C7CDDB]" />
        {/* drag handle */}
        <img
          src="/exclude.svg"
          alt=""
          draggable={false}
          className="relative z-10 h-[13px] w-[45px] pointer-events-none object-contain"
        />
      </div>
    )
  }

  // vertical
  return (
    <div
      className={cn(
        "relative z-10 flex h-full w-5 shrink-0 cursor-col-resize select-none items-center justify-center bg-[var(--ed-divider-bg)]",
        className,
      )}
      onMouseDown={onMouseDown}
      onDoubleClick={onDoubleClick}
    >
      {/* line — split above/below the icon so its 89%-opacity fill doesn't show
          a strip of line bleeding through it */}
      <div className="pointer-events-none absolute left-1/2 top-0 h-[calc(50%-20px)] w-px -translate-x-1/2 bg-[#C7CDDB]" />
      <div className="pointer-events-none absolute left-1/2 bottom-0 h-[calc(50%-20px)] w-px -translate-x-1/2 bg-[#C7CDDB]" />
      {/* drag handle — dedicated vertical SVG */}
      <img
        src="/excludeVertical.svg"
        alt=""
        draggable={false}
        className="relative z-10 pointer-events-none object-contain translate-x-[1px]"
      />
    </div>
  )
}
